import { useGetPrice } from '@services/contract/common/v3Pool.contract';

import { CHAIN_ID } from '@constants/common/chain.constants';
import { TokenPair, UNIV3_POOLS } from '@constants/common/tokens.constants';

const useEthPriceUsd = () => {
  const { data: ethUsdc, isPending: isPendingEthUsdc } = useGetPrice({
    pool: UNIV3_POOLS[CHAIN_ID.BASE]?.[TokenPair.USDC_ETH] || undefined,
    chainId: CHAIN_ID.BASE,
  });

  return {
    data: ethUsdc,
    isPending: isPendingEthUsdc,
  };
};

export default useEthPriceUsd;
